<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card height="500">
          <v-sheet v-if="loading" class="mt-2 d-flex align-center justify-center" rounded="" height="500" color="#eee">
            <v-progress-circular
              class=""
              indeterminate
              color="primary"
            />
          </v-sheet>
          <div v-else>
            <v-card-title>
              Umsatz
              <v-spacer />
              <v-text-field v-model="startDate" label="Start Datum" type="date" class="mr-4" @change="loadDatasets" />
              <v-text-field v-model="endDate" label="End Datum" type="date" class="mr-4" @change="loadDatasets" />
              <v-autocomplete v-model="selectedTeam" class="mr-4" label="Team" :items="teams" return-object item-text="name" @change="fetchTeam" />
              <v-autocomplete v-model="selectedVB" class="mr-4" label="VB" :items="contactPeople" return-object item-text="text" @change="fetchVb" />
              <v-autocomplete v-model="selectedDebitor" label="Debitor" :items="debitors" return-object item-text="name" @change="fetchDebitor" />
            </v-card-title>
            <v-card-text>
              <v-divider />
              <line-chart :chart-data="chartData" />
            </v-card-text>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LineChart from '@/Components/Chart/LineChart.vue'
import axios from 'axios'
// import axios from 'axios'
export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: 'Statistik - Kosten, Umsatz und Gewinn',
      }
   },
   components: {
      LineChart
   },
   props: {
      contactPeople: {
         type: Array,
         required: true
      },
      teams: {
         type: Array,
         required: true
      },
      debitors: {
         type: Array,
         required: true
      }
   },
   data () {
      return {
         chartData: {
            labels: [],
            datasets: [
               {
                  label: 'Monatliche Vertragsumsätze',
                  backgroundColor: '#e51f85',
                  borderColor: '#e51f85',
                  data: []
               }
            ]
         },
         loading: true,
         selectedVB: { text: 'Alle', id: null },
         selectedTeam: { name: 'Alle', id: null },
         selectedDebitor: { name: 'Alle', id: null },
         selected: 'Alle',
         startDate: null,
         endDate: null,
         requestType: 'all'

      }
   },
   created () {
      this.loadDatasets()
   },
   methods: {
      loadDatasets () {
         this.chartData.labels = []
         this.chartData.datasets[0].data = []
         this.loading = true

         if (this.selectedVB.id === null && this.requestType === 'vb') {
            this.requestType = 'all'
         }

         switch (this.requestType) {
         case 'vb':
            this.selected = 'VB ' + this.selectedVB.text
            if (this.selectedVB === null) return
            axios.get(this.route('contract-statistic.show', { vb: this.selectedVB.id, startDate: this.startDate, endDate: this.endDate })).then((response) => {
               this.loading = false
               for (const [key, value] of Object.entries(response.data.turnover)) {
                  this.chartData.labels.push(key)
                  this.chartData.datasets[0].data.push(value)
               }
            })
            break
         case 'team':
            this.selected = 'Team ' + this.selectedTeam.name
            axios.get(this.route('api.contract-statistic.team', { team: this.selectedTeam.id, startDate: this.startDate, endDate: this.endDate })).then((response) => {
               for (const [key, value] of Object.entries(response.data.turnover)) {
                  this.chartData.labels.push(key)
                  this.chartData.datasets[0].data.push(value)
               }
               this.loading = false
            })
            break
         case 'debitor':
            this.selected = 'Debitor ' + this.selectedDebitor.name
            axios.get(this.route('api.contract-statistic.debitor', { debitor: this.selectedDebitor.id, startDate: this.startDate, endDate: this.endDate })).then((response) => {
               for (const [key, value] of Object.entries(response.data.turnover)) {
                  this.chartData.labels.push(key)
                  this.chartData.datasets[0].data.push(value)
               }
               this.loading = false
            })
            break
         default:
            axios.get(this.route('contract-statistic.index', { startDate: this.startDate, endDate: this.endDate })).then((response) => {
               for (const [key, value] of Object.entries(response.data.turnover)) {
                  this.chartData.labels.push(key)
                  this.chartData.datasets[0].data.push(value)
               }
               this.startDate = response.data.startDate
               this.endDate = response.data.endDate

               this.loading = false
            })
            break
         }
      },

      fetchVb () {
         this.requestType = 'vb'
         this.selectedTeam = { name: 'Alle', id: null }
         this.selectedDebitor = { name: 'Alle', id: null }
         this.loadDatasets()
      },
      fetchTeam () {
         this.requestType = 'team'
         this.selectedDebitor = { name: 'Alle', id: null }
         this.selectedVB = { text: 'Alle', id: null }
         this.loadDatasets()
      },
      fetchDebitor () {
         this.requestType = 'debitor'
         this.selectedTeam = { name: 'Alle', id: null }
         this.selectedVB = { text: 'Alle', id: null }
         this.loadDatasets()
      },
   }
}
</script>

<style>

</style>
